"use client";

import { Button } from "@/components/ui/button";

/**
 * 대시보드 위젯 공통 조회 실패 안내 + 다시 시도(JCG-3854).
 * 조회 실패를 빈 결과 안내로 표시하지 않도록 `DashboardCardLoading`과 짝으로 쓴다.
 */
export default function DashboardCardError({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-4 text-center">
      <p role="alert" className="text-[13px] text-muted-foreground">
        {message}
      </p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        다시 시도
      </Button>
    </div>
  );
}
